/**
 * Salon is mounted under /salon (skin stays at /). Route prefix + storage keys
 * are isolated so the two flows do not share sessionStorage/localStorage entries.
 */

export const SALON_APP_BASE = '/salon';

/** Default entry: salon login. */
export const SALON_HOME_PATH = SALON_APP_BASE;

/** Post-login app picker (skin, makeup, hair coloring, hair cut, hair analyze). */
export const SALON_HUB_PATH = `${SALON_APP_BASE}/hub`;

/** Turn an app path like /user-info into /salon/user-info. `/` → `/salon` (landing). */
export function salonAppPath(path) {
  const raw = path == null || path === '' ? '/' : String(path);
  const p = raw.startsWith('/') ? raw : `/${raw}`;
  if (p === '/') return SALON_HOME_PATH;
  return `${SALON_APP_BASE}${p}`;
}

export const SALON_APP_SESSION_TOKEN_KEY = 'salon_app_session_token';
export const SALON_ORGANIZATION_ID_KEY = 'salon_organization_id';
export const SALON_ORG_PLAN_KEY = 'salon_org_plan';
export const SALON_LOGIN_FLAG_KEY = 'salon_auth_logged_in';
export const SALON_LOGIN_SESSION_TOKEN_KEY = 'salon_login_session_token';
/** Stored at login so logout can clear server session when the token is missing or stale. */
export const SALON_LOGIN_USERNAME_KEY = 'salon_login_username';
export const SALON_LOGIN_EXPIRES_AT_KEY = 'salon_login_expires_at';
export const SALON_LOGIN_DEVICE_ID_KEY = 'salon_login_device_id';
export const SALON_LAST_ACTIVITY_AT_KEY = 'salon_last_activity_at';
export const SALON_LOGIN_TIMEOUT_MINUTES_KEY = 'salon_login_timeout_minutes';
/** Set when login_session_token has been confirmed via POST /auth/validate (once per login). */
export const SALON_LOGIN_SERVER_VALIDATED_KEY = 'salon_login_server_validated';
export const SALON_SESSION_HOME_PATH_KEY = 'salon_session_home_path';
export const SALON_DETECTION_SESSION_KEY = 'salon_detection_session_id';
export const SALON_PENDING_SAVE_KEY = 'salon_pending_save_analysis_v1';
export const SALON_PAGE_SETUP_TOKEN_KEY = 'salon_page_setup_token';
export const SALON_PAGE_SETUP_DATA_PREFIX = 'salon_page_setup_data_';
export const SALON_FLOW_STATE_PREFIX = 'salon_flow_state_';
export const SALON_CACHE_KEY_PREFIX = 'salon_analysis_cache_';
export const SALON_PENDING_SAVES_KEY = 'salon_analysis_pending_saves';

/** localStorage key prefix for last saved customer profile on salon user-info (per app session token). */
export const SALON_LAST_CUSTOMER_PREFIX = 'salon_last_customer_v1_';

export function salonLastCustomerStorageKey(token) {
  const t = token && String(token).trim() ? String(token).trim() : '_default';
  return `${SALON_LAST_CUSTOMER_PREFIX}${t}`;
}
